import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Mounts from "@/pages/Mounts";
import SignIn from "@/pages/SignIn";
import AuthCallback from "@/pages/AuthCallback";
import MapApp from "@/pages/MapApp";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // Process OAuth return BEFORE any protected route runs
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/mounts" element={<Mounts />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/app" element={<ProtectedRoute><MapApp /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
